module.exports = __webpack_public_path__ + "static/media/empty-wallet-change.ffbcf7f4.svg";